import { useRecoilValue } from 'recoil'
import apiClient from '../service/api'
// eslint-disable-next-line import/no-cycle
import { currentWorkspace } from '../atoms'

const ClientApi = {
  /** dummy test code */
  asyncTest: async (success, timeout, dummy = {}) =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        if (success) {
          resolve(dummy)
        }
        reject(dummy)
      }, timeout || 700)
    }),

  resendVerifyEmail: async (userId) =>
    new Promise((resolve, reject) => {
      try {
        const response = apiClient.get(`/v1/auth/resend-verification?id=${userId}`)
        resolve(response)
      } catch (e) {
        reject(e)
      }
    }),

  project: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    get: async (id) => {
      const url = '/v1/projects/'
      return new Promise((resolve, reject) => {
        try {
          // let response = apiClient.get(`api/v1/projects${id ? id : ''}`);
          // resolve(response)
        } catch (e) {
          reject(e)
        }
      })
    },

    list: async () => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const workspace = useRecoilValue(currentWorkspace)

      return new Promise((resolve, reject) => {
        const url = `/v1/workspaces/${workspace.id}/projects`
        try {
          const response = apiClient.get(url)
          resolve(response)
        } catch (e) {
          reject(e)
        }
      })
    },

    create: async (body) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const workspace = useRecoilValue(currentWorkspace)

      return new Promise((resolve, reject) => {
        const url = `/v1/workspaces/${workspace.id}/projects`
        try {
          // Authorization 수동 부착 제거 (apiClient interceptor가 자동 처리)
          const response = apiClient.post(url, body)
          resolve(response)
        } catch (e) {
          reject(e)
        }
      })
    },
  },
}

// eslint-disable-next-line import/prefer-default-export
export { ClientApi }
